import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx";
import SellerNavbar from "../../component/SellerNavbar";
import SellerSidebar from "../../component/SellerSidebar";
import axios from "axios";
import Swal from "sweetalert2";
import { baseurl } from "../../Baseurl";
import excelsheet from "../../component/file/bulk_listings_template.xlsx";

const BulkUpload = () => {
  const [excelData, setExcelData] = useState([]);
  const [fileName, setFileName] = useState("");
  const [menus, setMenus] = useState([]);

  useEffect(() => {
    const fetchMenus = async () => {
      try {
        const res = await axios.get(`${baseurl}/getMenus`);
        setMenus(res.data);
      } catch (err) {
        console.error("Error fetching menus", err);
      }
    };
    fetchMenus();
  }, []);

  const validateAndMap = (data) => {
    return data.map((row) => {
      const keys = Object.keys(row);
      const categoryKey = keys[2]; // Assuming column 3 is category
      const categoryValue = String(row[categoryKey] || "");
      
      // Case-insensitive match
      const match = menus.find((m) => m.title.toLowerCase() === categoryValue.toLowerCase());

      return {
        ...row,
        category_val: categoryValue,
        category_key: categoryKey,
        is_valid: !!match,
        category_id: match ? match.id : null,
      };
    });
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    setFileName(file.name);
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const jsonData = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], { defval: "" });
      setExcelData(validateAndMap(jsonData));
    };
    reader.readAsArrayBuffer(file);
  };

  // Handle manual typing or dropdown selection
  const handleCategoryInputChange = (index, newValue) => {
    const newData = [...excelData];
    newData[index][newData[index].category_key] = newValue;
    setExcelData(validateAndMap(newData));
  };

  const handleSubmit = async () => {
    if (excelData.some(item => !item.is_valid)) {
      Swal.fire("⚠️ Validation Error", "Please ensure all categories are valid existing categories.", "warning");
      return;
    }

    const seller_id = localStorage.getItem("seller_id");
    const payload = excelData.map((item) => ({ ...item, seller_id, category_id: item.category_id }));

    try {
      await axios.post(`${baseurl}/bulkUploadProducts`, { products: payload });
      Swal.fire("✅ Success", "Products uploaded successfully!", "success");
    } catch (err) {
      Swal.fire("❌ Error", "Upload failed!", "error");
    }
  };

  return (
    <>
      <SellerNavbar />
      <div className="container-fluid mt-3">
        <div className="row g-2 justify-content-center">
          <div className="col-md-2"><SellerSidebar /></div>
          <div className="col-md-10">
            <div className="card shadow-sm border-0 p-4">
              <div className="d-flex justify-content-between mb-3">
                <h4 className="fw-bold">📦 Bulk Product Upload</h4>
                <button className="btn btn-outline-success btn-sm" onClick={() => window.location.href = excelsheet}>📥 Download Sample</button>
              </div>
              
              <input type="file" className="form-control mb-3" onChange={handleFileUpload} />
              
              {excelData.length > 0 && (
                <div className="table-responsive" style={{ maxHeight: "60vh", overflowY: "auto" }}>
                  <table className="table table-bordered table-sm align-middle">
                    <thead className="table-dark sticky-top">
                      <tr>{Object.keys(excelData[0]).filter(k => !k.includes('_')).map((k, i) => <th key={i}>{k}</th>)}</tr>
                    </thead>
                    <tbody>
                      {excelData.map((row, idx) => (
                        <tr key={idx} className={!row.is_valid ? "table-danger" : ""}>
                          {Object.entries(row).filter(([key]) => !key.includes('_')).map(([key, val], colIdx) => (
                            <td key={colIdx}>
                              {key === row.category_key ? (
                                <>
                                  <input 
                                    className="form-control form-control-sm"
                                    list={`category-list-${idx}`}
                                    value={val}
                                    onChange={(e) => handleCategoryInputChange(idx, e.target.value)}
                                    placeholder="Type or select category..."
                                  />
                                  <datalist id={`category-list-${idx}`}>
                                    {menus.map(m => <option key={m.id} value={m.title} />)}
                                  </datalist>
                                </>
                              ) : val}
                            </td>
                          ))}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
              <button className="btn btn-primary mt-3" onClick={handleSubmit} disabled={!excelData.length}>🚀 Finalize Upload</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkUpload;